<template>
	<v-container fluid style="text-align:left; background-color: white !important;">
		<v-row class="border-all">
			<v-col cols="12">
				<div class="title">
					Informe de Tratamiento de Sanidad Ambiental
				</div>
				<div class="subtitle-1">Control integrado de Plagas</div>
			</v-col>
			<v-col cols="4" class=""
				>N° <b>{{ order[0] }}</b></v-col
			>
			<v-col cols="4" class="" v-for="(email, index) in place.email" :key="index"
				>Correo <b>{{ email }}</b></v-col
			>
			<v-col cols="4" class=""
				>Dirección perimetral: <b>{{ place.address }}</b></v-col
			>
			<v-col cols="4" class=""
				>Fecha <b>{{ order[1] }}</b></v-col
			>
			<v-col cols="4" class=""
				>Cliente <b>{{ order[3] }}</b></v-col
			>
			<v-col cols="4" class=""
				>Dirección <b>{{ order[4] }}</b></v-col
			>
			<v-col cols="4" class=""
				>Correo <b>{{ order[order.length - 2] }}</b></v-col
			>
			<v-col cols="4" class=""
				>At. sr(a) <b>{{ order[5] }}</b></v-col
			>
			<v-col cols="6" class="border-a"
				>Lugar de servicio <b>{{ order[6] }}</b></v-col
			>
			<v-col cols="6" class="border-a"
				>Tipo de servicio <b>{{ order[7] }}</b></v-col
			>
		</v-row>
		<v-row class="border-all">
			<v-col cols="12" class="mt-6">
				<div class="subtitle-1">
					Agroservice Ing. Asoc. certifica haber ejecutado los siguientes tratamientos de
					Sanidad Ambiental
				</div>
			</v-col>
			<v-col cols="2" class=" grey lighten-4 border-a">Tratamiento</v-col>
			<v-col cols="3" class="grey lighten-4 border-a">Ingredientes Activos</v-col>
			<v-col cols="1" class="grey lighten-4 border-a">%</v-col>
			<v-col cols="2" class="grey lighten-4 border-a">Dosis de Aplicacion</v-col>
			<v-col cols="4" class="grey lighten-4 border-a">Dependencia Tratada</v-col>
			<v-col cols="2" class="border-a">Sanitizado</v-col>
			<v-col cols="3" class="border-a">
				<div>
					<div>
						Amonio cuaternario
						<v-icon v-if="order[8] == 'Si'" small>mdi-check</v-icon>
						<v-icon v-else small>mdi-border-all-variant</v-icon>
					</div>
					<div>
						Extracto de cítrico
						<v-icon v-if="order[9] == 'Si'" small>mdi-check</v-icon>
						<v-icon v-else small>mdi-border-all-variant</v-icon>
					</div>
				</div>
			</v-col>
			<v-col cols="1" class="border-a">
				<div>
					<div>
						<b>{{ order[10] !== 'Sin info' ? order[10] : 0 }}</b> %
					</div>
					<div>
						<b>{{ order[11] !== 'Sin info' ? order[11] : 0 }}</b> %
					</div>
				</div>
			</v-col>
			<v-col cols="2" class="border-a">
				<div>
					40cc/4lts H2O <v-icon v-if="order[12] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon>
				</div>
				<div>
					60cc/10lts H2O <v-icon v-if="order[13] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon>
				</div>
				<div>
					90cc/10lts H2O <v-icon v-if="order[14] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon>
				</div>
			</v-col>
			<v-col cols="4" class="border-a"> </v-col>
			<v-col cols="2" class="border-a">Desinsectado</v-col>
			<v-col cols="3" class="border-a">
				<div>
					Cipermetrina+Trasnstetrametrina
					<v-icon v-if="order[15] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon>
				</div>
				<div>
					Lambdacibalotrina
					<v-icon v-if="order[16] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon>
				</div>
				<div>
					Deltametrina+Pirimifos Metril
					<v-icon v-if="order[17] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon>
				</div>
				<div>
					Sulfluramida
					<v-icon v-if="order[18] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon>
				</div>
				<div v-if="order[20] !== 'Sin info'">
					<b>{{ order[20] }}</b>
					<v-icon v-if="order[19] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon>
				</div>
			</v-col>
			<v-col cols="1" class="border-a">
				<div>15%, 25%</div>
				<div>2.5%</div>
				<div>1%, 25%</div>
				<div>1%</div>
				<div v-if="order[21] !== 'Sin info'">
					<b>{{ order[21] }}</b
					>%
				</div>
			</v-col>
			<v-col cols="2" class="border-a">
				<div>
					<b>{{ order[22] }}</b>
				</div>
				<div>
					<b>{{ order[23] }}</b>
				</div>
				<div>
					<b>{{ order[24] }}</b>
				</div>
				<div>
					<b>{{ order[25] }}</b>
				</div>
				<div>
					<b>{{ order[26] }}</b>
				</div>
			</v-col>
			<v-col cols="4" class="border-a">
				<v-row>
					<v-col cols="6">
						<div>
							Pueblo chico
							<v-icon v-if="order[27] == 'Si'" small>mdi-check</v-icon>
							<v-icon v-else small>mdi-border-all-variant</v-icon>
						</div>
						<div>
							Cocina
							<v-icon v-if="order[28] == 'Si'" small>mdi-check</v-icon>
							<v-icon v-else small>mdi-border-all-variant</v-icon>
						</div>
						<div>
							Habitación
							<v-icon v-if="order[29] == 'Si'" small>mdi-check</v-icon>
							<v-icon v-else small>mdi-border-all-variant</v-icon>
						</div>
						<div>
							SS.HH
							<v-icon v-if="order[30] == 'Si'" small>mdi-check</v-icon>
							<v-icon v-else small>mdi-border-all-variant</v-icon>
						</div>
						<div>
							Bodega
							<v-icon v-if="order[31] == 'Si'" small>mdi-check</v-icon>
							<v-icon v-else small>mdi-border-all-variant</v-icon>
						</div>
						<div>
							Oficina
							<v-icon v-if="order[32] == 'Si'" small>mdi-check</v-icon>
							<v-icon v-else small>mdi-border-all-variant</v-icon>
						</div>
						<div>
							Salas de cambios
							<v-icon v-if="order[33] == 'Si'" small>mdi-check</v-icon>
							<v-icon v-else small>mdi-border-all-variant</v-icon>
						</div>
					</v-col>
					<v-col cols="6">
						<div>
							Antejardín
							<v-icon v-if="order[34] == 'Si'" small>mdi-check</v-icon>
							<v-icon v-else small>mdi-border-all-variant</v-icon>
						</div>
						<div>
							Patio interior
							<v-icon v-if="order[35] == 'Si'" small>mdi-check</v-icon>
							<v-icon v-else small>mdi-border-all-variant</v-icon>
						</div>
						<div>
							Vehículos
							<v-icon v-if="order[36] == 'Si'" small>mdi-check</v-icon>
							<v-icon v-else small>mdi-border-all-variant</v-icon>
						</div>
						<div>
							Buses
							<v-icon v-if="order[37] == 'Si'" small>mdi-check</v-icon>
							<v-icon v-else small>mdi-border-all-variant</v-icon>
						</div>
						<div>
							Camion
							<v-icon v-if="order[38] == 'Si'" small>mdi-check</v-icon>
							<v-icon v-else small>mdi-border-all-variant</v-icon>
						</div>
						<div>
							Otros__ <b>{{ order[40] }}</b>
							<v-icon v-if="order[39] == 'Si'" small>mdi-check</v-icon>
							<v-icon v-else small>mdi-border-all-variant</v-icon>
						</div>
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="2" class="border-a">Desratizado</v-col>
			<v-col cols="3" class="border-a">
				<div>
					Bromadiolona
					<v-icon v-if="order[41] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon>
				</div>
				<div>
					Brodifacoum
					<v-icon v-if="order[42] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon>
				</div>
				<div v-if="order[44] !== 'Sin info'">
					<b>{{ order[44] }}</b>
					<v-icon v-if="order[43] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon>
				</div>
			</v-col>
			<v-col cols="1" class="border-a">
				<div>
					<b>{{ order[45] !== 'Sin info' ? order[45] : 0 }}</b> gr/100g
				</div>
				<div>
					<b>{{ order[46] !== 'Sin info' ? order[46] : 0 }}</b> gr/100g
				</div>
				<div v-if="order[47] !== 'Sin info'">
					<b>{{ order[47] }}</b>
				</div>
			</v-col>
			<v-col cols="2" class="border-a">
				<div>
					S. Pellet x25gr <v-icon v-if="order[48] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon>
				</div>
				<div>
					Bloque x16gr
					<v-icon v-if="order[49] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon>
				</div>
				<div>
					S. Molienda x20gr
					<v-icon v-if="order[50] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon>
				</div>
				<div>
					Minibloque x0,8gr
					<v-icon v-if="order[51] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon>
				</div>
			</v-col>
			<v-col cols="4" class="border-a">
				<div>
					Cambiaron los cebos
					<v-icon v-if="order[52] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon> Cantidad
					<b>{{ order[53] }}</b>
				</div>
				<div>
					Se Repusieron
					<v-icon v-if="order[54] == 'Si'" small>mdi-check</v-icon>
					<v-icon v-else small>mdi-border-all-variant</v-icon> Cantidad
					<b>{{ order[55] }}</b>
				</div>
				<div>
					Estado de sebo: <b>{{ order[56] }}</b>
				</div>
			</v-col>
		</v-row>
		<v-row justify="space-between" class="mt-4 border-all">
			<v-col class="border-a">
				<div>
					Antídoto Insecticida: No se conoce antídoto específico. Tratamiento sintomático
					bajo
				</div>
				<div>supervisión médica. Antídoto Rodenticida: Vitamina K1</div>
				<div>
					Observaciones: <b>{{ order[57] }}</b>
				</div>
			</v-col>
			<v-col cols="3" class="text-center border-a" v-if="order[59] !== 'Sin info'">
				OT autorizada con fotografía:
				<v-img
					lazy-src="@/assets/placeholder.png"
					:src="order[59]"
					max-height="200px"
					max-width="200px"
					style="border-radius: 15px;"
					alt="imagen de la orden"
				>
					<div class="bg caption text-right">
						{{ dateTime }}
					</div>
				</v-img>
			</v-col>
		</v-row>
		<v-row>
			<template v-if="images">
				<v-col cols="12">
					Antecedentes fotográficos:
				</v-col>
				<div v-for="(img, key) in images" :key="key" class="d-flex child-flex ">
					<v-img
						lazy-src="@/assets/placeholder.png"
						:src="img.url"
						max-height="200px"
						max-width="200px"
						class="mr-1 mb-1"
						style="border-radius: 15px;"
						alt="imagen de la orden"
					>
						<div class="bg caption text-right" v-if="img.createdAt">
							{{ createAt(img.createdAt) }}
						</div>
					</v-img>
				</div>
			</template>
		</v-row>
	</v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
	props: {
		workOrder: {
			type: Array,
		},
	},
	data() {
		return {
			idLodging: undefined,
			indexWorkOrder: undefined,
			order: [],
			place: '',
			images: [],
		};
	},
	computed: {
		dateTime() {
			return moment(this.order[58]).format('lll');
		},
		...mapGetters({
			lodgingSelect: 'Lodging/lodgingSelect',
		}),
	},
	watch: {
		workOrder() {
			this.order = this.workOrder;
		},
	},
	created() {
		if (!this.$vuetify.breakpoint.lgAndUp)
			document.getElementById('viewport').setAttribute('content', 'width=1100');
	},
	mounted() {
		this.idLodging = this.$route.params.idLodging;
		this.indexWorkOrder = this.$route.params.index;

		if (this.workOrder) {
			this.order = this.formatWorkOrder(this.workOrder);
			this.place = this.lodgingSelect.place;
			if (this.lodgingSelect.documents) {
				const documents = this.lodgingSelect.documents;
				this.images = documents.filter(document => {
					const typeDocument = document.url.slice(-3);
					if (this.validateImage(typeDocument)) return true;
					return false;
				});
			}
		} else if (this.idLodging && this.indexWorkOrder)
			this.getWorkOrder({
				idLodging: this.idLodging,
				indexWorkOrder: this.indexWorkOrder,
			}).then(data => {
				this.order = this.formatWorkOrder(data.workOrder);
				this.place = data.place;
				this.images = data.documents.filter(document => {
					const typeDocument = document.url.slice(-3);
					if (this.validateImage(typeDocument)) return true;
					return false;
				});
			});
	},
	methods: {
		validateImage(typeDocument) {
			typeDocument = typeDocument.toLowerCase();
			if (typeDocument === 'jpg' || typeDocument === 'png' || typeDocument === 'peg')
				return true;
			return false;
		},
		createAt(date) {
			if (date) return moment(date).format('lll');
			else return 'Sin fecha';
		},
		formatWorkOrder(workOrder) {
			return workOrder.map(item => {
				if (item === null || item === false) return 'Sin info';
				if (item === true) return 'Si';
				else return item;
			});
		},
		...mapActions({
			getWorkOrder: 'Lodging/getWorkOrder',
		}),
	},
};
</script>
<style media="screen">
.border-a {
	border-bottom: 2px solid gray !important ;
	margin-bottom: 2px;
}
.border-all {
	border-left: 1px solid gray;
	border-right: 1px solid gray;
	border-top: 1px solid gray;
	margin-bottom: 2px;
}
.bg {
	background-color: rgba(0, 0, 0, 0.1);
}
</style>
